import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeMode } from './createAppTheme';

interface ThemeModeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggleHighContrast: () => void;
}

export const useThemeModeStore = create<ThemeModeState>()(
  persist(
    (set, get) => ({
      mode: 'light',
      setMode: (mode) => {
        set({ mode });
      },
      toggleHighContrast: () => {
        set({ mode: get().mode === 'high-contrast' ? 'light' : 'high-contrast' });
      },
    }),
    { name: 'tms-theme-mode' },
  ),
);
